import { useEffect, useRef } from 'react';
import './Banner.css';
import company1 from '../assets/company_logos/company1.svg';
import company2 from '../assets/company_logos/company2.svg';
import company3 from '../assets/company_logos/company3.svg';
import company4 from '../assets/company_logos/company4.svg';
import company5 from '../assets/company_logos/company5.svg';
import company6 from '../assets/company_logos/company6.svg';
import company7 from '../assets/company_logos/company7.svg';
import company8 from '../assets/company_logos/company8.svg';
import company9 from '../assets/company_logos/company9.svg';
import company10 from '../assets/company_logos/company10.svg';
import company11 from '../assets/company_logos/company11.svg';
import company12 from '../assets/company_logos/company12.svg';
import company13 from '../assets/company_logos/company13.svg';
import company14 from '../assets/company_logos/company14.svg';
import company15 from '../assets/company_logos/company15.svg';

const Banner = () => {
  const companyLogos = [
    company1,
    company2,
    company3,
    company4,
    company5,
    company6,
    company7,
    company8,
    company9,
    company10,
    company11,
    company12,
    company13,
    company14,
    company15,
  ];

  // Duplicate the logos array to create a seamless loop
  const doubleLogos = [...companyLogos, ...companyLogos];
  const marqueeRef = useRef(null);

  return (
    <section className="bg-[#030507] text-white py-6">
      <div className="w-full max-w-[1344px] mx-auto px-4 sm:px-0">
        {/* Heading */}
        <h2 
          className="text-[12px] sm:text-[14px] font-medium tracking-[-0.02em] pb-2 mb-4"
          style={{ 
            color: 'rgba(120, 124, 135, 0.5)',
            fontFamily: 'Geist, system-ui, sans-serif',
            fontWeight: 300,
            letterSpacing: '-0.02em',
            paddingBottom: '0px'
          }}
        >
          Powered by Technologien, die Wirkung entfalten
        </h2>
        
        {/* Marquee Container */}
        <div className="relative mt-3 sm:-mx-5 sm:mt-1.5 sm:w-[calc(100%+40px)] before:absolute before:left-0 before:top-0 before:z-10 before:h-full before:w-[100px] before:bg-gradient-to-r before:from-[#030507] before:to-transparent md:before:w-20 sm:before:w-12 after:absolute after:right-0 after:top-0 after:z-10 after:h-full after:w-[100px] after:bg-gradient-to-l after:from-[#030507] after:to-transparent md:after:w-20 sm:after:w-12">
          <div className="marquee">
          <div className="marquee__inner-wrap">
            <div className="marquee__inner" ref={marqueeRef}>
              {doubleLogos.map((logo, index) => (
                <img 
                  key={index} 
                  src={logo} 
                  alt={`Company ${index % companyLogos.length + 1}`} 
                  className="marquee__img"
                  loading="lazy"
                />
              ))}
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
